import { useDtsAppContext } from "../components/provider/DtsAppContextProvider";

export const useApi = () => {
  //言語切替用
  // ローディング表示（Contextから取得）
  const { loading, setLoading } = useDtsAppContext();

  const handleApi = async (apiFunction: any, ...args: any) => {
    try {
      // ローディング開始
      setLoading(true);

      //API処理
      const result = await apiFunction(...args);
      //結果を返す
      return result;
    } catch (error) {
      console.error("[useApi] Error:", error);
      throw error;
    } finally {
      // ローディング終了
      setLoading(false);
    }
  };

  return {
    loading,
    handleApi,
  };
};
